import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import ClassificationBannerHeader from '../common/banner/classifactionBannerHeader';
import PageHeader from '../common/banner/pageHeader';

export default function BandwidthUsage() {

  const baseRoute = process.env.REACT_APP_BASE_ROUTE || '/';
  const imgRoute = 'images/analytics/bandwidthUsage.png';
  const route = baseRoute + imgRoute;

  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="CCG Dashboards"></PageHeader>
      </Box>
      <Typography variant='h4' 
        sx ={{display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '1.35em', 
              marginBottom: '10px'}}>
        Bandwidth Usage
      </Typography>
      <Box
        sx={{          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <img 
            alt="Cve Info"
            src={route}
            width="100%"
            height="100%"
            style={{ border: 'none', display: 'flex', objectFit: 'fit', marginBottom: '-70px'  }}
        />
      </Box>
    </Container>
  );
};
